import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'status'
})

/**
 * Pipe para transformar status.
 * 
 * INSTRUCCIONES DE USO: 
 * 1) Importar PipesModule en el módulo donde quieras tranformar status
 * 2) Utilizar el pipe 'status' en el html de tu componente
 */

export class statusPipe implements PipeTransform {

    public lenguages: ILanguage = {
        es: {
            APPROVED: "APROBADO",
            REJECTED: "RECHAZADO",
            PENDING: "PENDIENTE",
            CANCELLED: "CANCELADO",
            INPROGRESS: "EN PROCESO",
            DONE: "COMPLETADO",
            ACCESS: "ACCESO",
            CAFETERIA: "CAFETERIA",
            LOST: "PERDIDA",
            REPLACEMENT: "REMPLAZO",
            MOBILE: "MÓVIL",
            TABLET: "TABLET",
            ACTIVE: "ACTIVO",
            INACTIVE: "INACTIVO",
            VISIBLE: "VISIBLE",
            NOVIVIBLE: "NO VISIBLE",
            DENIED: "DENEGADO",
            ACCEPT: "PERMITIDO",
            PREVENTIVE: "PREVENTIVO",
            VACATION: "VACACIONES",
            PERMISSION: "PERMISO",
            LEAVEDAY: "PERMISO POR DÍA",
            LEAVEHOUR: "PERMISO POR HORA",
            WIFI: "WIFI",
            CELLULAR: "Datos Móviles",
            NONE: "Sin conexion",
            UNKNOWN: "Desconocido",
            NUEVO: "NUEVO",
            ANALIZANDO: "ANALIZANDO",
            TRABAJANDO: "TRABAJANDO",
            RESUELTO: "RESUELTO",
            LIBERADO: "LIBERADO",
            CREATED: "CREADO",
            CLOSED: "CERRADO",
            DELETED: "ELIMINADO",
            LOWER: "MENOR",
            GREATER: "MAYOR",
            LOWEROREQUAL: "MENOR O IGUAL",
            GREATEROREQUAL: "MAYOR O IGUAL",
            EQUAL: "IGUAL",
            NOTEQUALS: "DIFERENTE",
            AUTHORIZED: "AUTORIZADA",
            OPEN: "ABIERTO",
            COMPLETED: "COMPLETADO",
            LESS_IS_BETTER: "MENOR ES MEJOR",
            MORE_IS_BETTER: "MÁS ES MEJOR",
            CALIBRATED: "CALIBRADO",
            PUBLISHED: "PUBLICADO",
            EMPLOYEE: "EMPLEADO",
            BRANCH: "PLANTA",
            DEPARTMENT: "DEPARTAMENTO",
            POSITION: "PUESTO",

        },
        en: {
            APPROVED: "APPROVED",
            REJECTED: "REJECTED",
            PENDING: "PENDING",
            CANCELLED: "CANCELLED",
            INPROGRESS: "IN PROGRESS",
            DONE: "DONE",
            ACCESS: "ACCESS",
            CAFETERIA: "CAFETERIA",
            LOST: "LOST",
            REPLACEMENT: "REPLACEMENT",
            MOBILE: "MOBILE",
            TABLET: "TABLET",
            ACTIVE: "ACTIVE",
            INACTIVE: "INACTIVE",
            VISIBLE: "VISIBLE",
            NOVIVIBLE: "NOT VISIBLE",
            DENIED: "DENIED",
            ACCEPT: "ACCEPT",
            PREVENTIVE: "PREVENTIVE",
            VACATION: "VACATION",
            PERMISSION: "PERMISSION",
            NUEVO: "NEW",
            ANALIZANDO: "ANALYZING",
            TRABAJANDO: "WORKING",
            RESUELTO: "RESOLVED",
            LIBERADO: "RELEASED",
            COMPLETED: "COMPLETED",
            CREATED: "CREATED",
            CLOSED: "CLOSED",
            DELETED: "DELETED",
            LOWER: "LOWER",
            GREATER: "GREATER",
            LOWEROREQUAL: "LESS OR EQUAL",
            GREATEROREQUAL: "GREATER OR EQUAL",
            EQUAL: "EQUAL",
            NOTEQUALS: "DIFFERENT",
            AUTHORIZED: "AUTHORIZED",
            OPEN: "OPEN",
            LESS_IS_BETTER: "LESS IS BETTER",
            MORE_IS_BETTER: "MORE IS BETTER",
            LEAVEDAY: "LEAVE PER DAY",
            LEAVEHOUR: "LEAVE PER HOUR",
            WIFI: "WIFI",
            CELLULAR: "Mobile data",
            NONE: "NO CONNECTION",
            UNKNOWN: "UNKNOWN"
        }
    }
    constructor() { }

    transform(value: string, locale: string = "es"): string {
        return value ? this.lenguages[locale][value.toUpperCase()] || value : "";
    }

}

interface ILanguage {
    en?: any,
    es?: any,
}

